// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useState } from 'react'
import './resetPassword.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { PageLoadingSpinner, ResetPassword as ResetPasswordUI, useAdjustPageHeadEntities } from 'ui_kit_qmd'
import { clear500Error } from '../../app/authState'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { validateEmail } from '../../utils/common'
import { ErrorAlert } from '../../components/ui_kit_quickMD/error-alert/erroralert'
import errorIcon from '../../images/common/error-icon.svg'
import { reset, setResetPasswordError } from '../../store/resetPassword/resetPasswordActions'
import {
  createPasswordForNewMember,
  resendForgotPassword,
  updatePassword,
} from '../../store/resetPassword/resetPasswordThunk'
import { QUICK_MD_TITLE_TEXT } from '../../utils/constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export default function ResetPassword({ type }) {
  const params = new URLSearchParams(window.location.search)
  const token = params.get('token')
  const [confirmValue, setConfirmValue] = useState('')
  const [passwordValue, setPasswordValue] = useState('')
  const [emailValue, setEmailValue] = useState('')
  const [passwordError, setPasswordError] = useState('')
  const [emailError, setEmailError] = useState('')
  const [checkerStarted, setCheckerStarted] = useState(false)
  const [isPasswordValid, setPasswordValid] = useState(false)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.resetPassword.error)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loading = useSelector((state) => state.resetPassword.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const success = useSelector((state) => state.resetPassword.success)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const tokenExpired = useSelector((state) => state.resetPassword.tokenExpired)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const emailSentSuccess = useSelector((state) => state.resetPassword.emailSentSuccess)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const emailToVerify = useSelector((state) => state.resetPassword.emailToVerify)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const loginSuccess = useSelector((state) => state.auth.accessToken)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const isNetworkError = useSelector((state) => state.auth.isNetworkError)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const verifyEmailTitle = tokenExpired ? 'Link Expired' : 'Create Password'
  const resetPasswordTitle = tokenExpired ? 'Link Expired' : 'Reset Password'
  const pageTitle = type === 'verifyEmail' ? verifyEmailTitle : resetPasswordTitle
  const pageHeader = useAdjustPageHeadEntities({
    title: loading ? QUICK_MD_TITLE_TEXT : pageTitle,
  })
  useEffect(
    () => () => {
      document.title = QUICK_MD_TITLE_TEXT
    },
    [],
  )

  const onSubmitPassword = useCallback(() => {
    if (success || emailSentSuccess) {
      navigate('/')
      dispatch(reset())
      return
    }
    if (!isPasswordValid) {
      setPasswordError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS))
      if (!checkerStarted) {
        setCheckerStarted(true)
      }
      return
    }
    if (passwordValue !== confirmValue) {
      setPasswordError(getUserFriendlyErrorMessage(errorCodes.PASSWORDS_DO_NOT_MATCH))
      if (!checkerStarted) {
        setCheckerStarted(true)
      }
      return
    }
    setPasswordError('')
    if (type === 'verifyEmail') {
      dispatch(createPasswordForNewMember({ Password: passwordValue, Token: token }))
    } else if (type === 'resetPassword') {
      dispatch(updatePassword({ Password: passwordValue, Token: token }))
    }
  }, [
    checkerStarted,
    confirmValue,
    dispatch,
    emailSentSuccess,
    isPasswordValid,
    navigate,
    passwordValue,
    success,
    token,
    type,
  ])

  useEffect(() => {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const handleEnterPressEvent = (e) => {
      if (e.key === 'Enter') {
        onSubmitPassword()
      }
    }
    window.addEventListener('keyup', handleEnterPressEvent)
    return () => window.removeEventListener('keyup', handleEnterPressEvent)
  }, [passwordValue, confirmValue])

  useEffect(() => {
    if (loginSuccess && type !== 'verifyEmail') {
      navigate('/management')
    }
  }, [loginSuccess])

  useEffect(() => {
    if (isNetworkError) {
      setTimeout(() => {
        dispatch(clear500Error())
      }, 3500)
    }
  }, [isNetworkError])

  useEffect(() => {
    if (error === getUserFriendlyErrorMessage(errorCodes.NEW_PASSWORD_MUST_BE_DIFFERENT)) {
      setPasswordError(error)
    }

    if (error === getUserFriendlyErrorMessage(errorCodes.DEFAULT)) {
      setTimeout(() => {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(setResetPasswordError())
      }, 3500)
    }
  }, [error])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetConfirmPassword = useCallback((value) => {
    setConfirmValue(value)
    setPasswordError('')
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetPassword = useCallback((value) => {
    setPasswordValue(value)
    setPasswordError('')
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetEmail = useCallback((value) => {
    setEmailValue(value)
    setEmailError('')
  }, [])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onSetValidPassword = useCallback((value) => {
    setPasswordValid(value)
  }, [])

  const onSubmitEmail = useCallback(() => {
    setEmailError('')
    if (!emailValue) {
      setEmailError(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, 'Email'))
    } else if (!validateEmail(emailValue)) {
      setEmailError(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'email'))
    } else {
      dispatch(resendForgotPassword({ Email: emailValue }))
    }
  }, [dispatch, emailValue])

  if (success && type === 'verifyEmail') {
    navigate('/')
  }

  return (
    <>
      {pageHeader}
      <ResetPasswordUI
        className='reset-password-container'
        emailSentSuccess={emailSentSuccess}
        emailError={emailError}
        onSetEmail={onSetEmail}
        onSubmitEmail={onSubmitEmail}
        type={type}
        tokenExpired={tokenExpired}
        confirmValue={confirmValue}
        success={success}
        onSetPassword={onSetPassword}
        onSetConfirmPassword={onSetConfirmPassword}
        passwordError={passwordError}
        onSetValidPassword={onSetValidPassword}
        passwordValue={passwordValue}
        checkerStarted={checkerStarted}
        emailToVerify={emailToVerify}
        onSubmitPassword={onSubmitPassword}
        loading={loading}
      />
      {isNetworkError ?
        // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered
        <ErrorAlert
          errorImg={errorIcon}
          imgAlt='errorIcon'
          errorText={getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION)}
        />
      : null}
      {error === getUserFriendlyErrorMessage(errorCodes.DEFAULT) && (
        // @ts-expect-error TS2741 -- MIGRATION: not approved, fix when encountered
        <ErrorAlert errorImg={errorIcon} imgAlt='errorIcon' errorText={error} />
      )}
      {loading ?
        <PageLoadingSpinner />
      : null}
    </>
  )
}
